import { useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { DateTime } from 'luxon';
// This hook determines whether we have a valid or invalid query param depending on the feature gate
// if feature gate is off, we use swapFromDate
// if feature gate is on, we use shiftStart
// once the feature gate is no longer needed, remove the swapFromDate query param
export var useIsValidSwapQueryParam = function (_a) {
    var swapFromDate = _a.swapFromDate, shiftStart = _a.shiftStart;
    var features = useAssociateContext().features;
    if (features.canSeeMultipleShiftSwap) {
        return !!shiftStart && DateTime.fromISO(shiftStart).isValid;
    }
    return !!swapFromDate && DateTime.fromISO(swapFromDate).isValid;
};
